module.exports = __webpack_public_path__ + "static/media/15.c76501a3.png";